import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import PTInput from "../../../../components/GenericComponents/PTInput";
import ArrowUpIcon from '../../../../assets/Icons/admin-arrow-up.svg';
import ArrowDownIcon from '../../../../assets/Icons/admin-arrow-down.svg';
import { Actions } from "../../../../store/actions";
import { dispatch } from "../../../../utils/utility/store";
import InvestorCard from '../InvestorCard';

export default function InvestorListCard(props) {
  const { unsaveChange } = props

  // State
  const [activeSearchbar, setActiveSearchbar] = useState(false)
  const [searchText, setSearchText] = useState('')

  // Store
  const { investors, isInvestorSelected, selectedInvestor, activeSort, sortOrder, isArchived } = useSelector(state => state.adminInvestor)

  const handleSort = (sort) => {
    dispatch(Actions.AdminInvestor.SetActiveSort, sort)
    dispatch(Actions.AdminInvestor.SetSortOrder, sort === activeSort ? sortOrder === 'ASC' ? 'DESC' : 'ASC' : 'ASC')
  }

  const handleArchived = () => {
    dispatch(Actions.AdminInvestor.SetIsArchived, !isArchived)
  }

  const handleSearch = (e) => {
    let text = e.target.value ? e.target.value.trim() : ''
    setSearchText(e.target.value)
    if (e.key === 'Enter') {
      setSearchText(text)
      dispatch(Actions.AdminInvestor.SetSearch, text)
      dispatch(Actions.AdminInvestor.SetIsSelectedInvestor, false)
      dispatch(Actions.AdminInvestor.SetSelectedInvestor, null)
    }
  }

  const handleCloseSearch = () => {
    dispatch(Actions.AdminInvestor.SetSearch, '')
    setActiveSearchbar(false)
    setSearchText('')
  }

  useEffect(() => {
    const element = document.getElementById('investorList');
    let totalHight = 0;
    if (isInvestorSelected && investors?.length) {
      investors.every(v => {
        let cardHeight = document.getElementById(`investor-${v?.id}`)?.clientHeight || 0
        if (selectedInvestor?.id && selectedInvestor?.id === v?.id) {
          dispatch(Actions.AdminInvestor.SetSelectedInvestor, v)
          return false
        } else totalHight += cardHeight;
        return true;
      });
      if (element.clientHeight < totalHight) {
        element.scrollTo(0, totalHight);
      }
    }
  }, [isInvestorSelected, selectedInvestor, investors])


  return (
    <>
      <div className='w-full h-[80px] flex items-center justify-between box-border pl-[15px] pr-[15px] xlg:pl-[30px] xlg:pr-[24px] bg-[#E7E8EC]'>
        {activeSearchbar ?
          <PTInput label="Search" fullWidth value={searchText} onKeyPress={handleSearch} handleOnChangeEvent={handleSearch} variant="standard" placeholder='' icon={<CloseIcon className='cursor-pointer' onClick={handleCloseSearch} />} /> :
          <>
            <div className='search-icon-wrap h-[30px] w-[30px] rounded-full bg-[#fff] cursor-pointer inline-flex items-center justify-center' onClick={() => setActiveSearchbar(true)}>
              <SearchIcon className='cursor-pointer text-[#70778E] w-[20px] h-[20px]' />
            </div>
            <div className='flex font-semibold text-[12px] whitespace-nowrap not-italic uppercase'>
              <div className={`flex cursor-pointer opacity-${isArchived ? '100' : '40'}`} style={{ marginRight: '10px' }} onClick={handleArchived}>
                <input type="checkbox" checked={isArchived} className='mr-[6px] bg-[#E7E8EC] accent-[#111D43]' />
                <span>archived</span>
              </div>
              <div className={`flex cursor-pointer opacity-${activeSort === 'name' ? '100' : '40'}`} style={{ marginRight: '10px' }} onClick={() => handleSort('name')}>
                <img src={activeSort === 'name' && sortOrder === 'DESC' ? ArrowDownIcon : ArrowUpIcon} alt="Icon" style={{ marginRight: '6px' }} />
                <span>A-Z</span>
              </div>
              <div className={`flex cursor-pointer opacity-${activeSort === 'createdAt' ? '100' : '40'}`} style={{ marginRight: '' }} onClick={() => handleSort('createdAt')}>
                <img src={activeSort === 'createdAt' && sortOrder === 'DESC' ? ArrowDownIcon : ArrowUpIcon} alt="Icon" style={{ marginRight: '6px' }} />
                <span>Date Created</span>
              </div>
            </div>
          </>}
      </div>
      <div id="investorList" className='mr-[-4px] md:mr-[0] h-[168px] md:h-[calc(100%-50px)] xlg:h-[calc(100%-80px)] overflow-y-auto hide-scrollbar'>
        {investors.length !== 0 && investors.map(investor => {
          return <InvestorCard
            key={investor?.id}
            investor={investor}
            unsaveChange={unsaveChange}
          />
        })}
      </div>
      {/* <ProptechSortMenu anchorEl={anchorEl} open={open} handleClose={handleClose} setSelectesFilter={setSelectesFilter} /> */}
    </>
  )
}
